import { render } from "./Timelines.vue?vue&type=template&id=48b8d4d1"
import script from "./Timelines.vue?vue&type=script&lang=js"
export * from "./Timelines.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__